import type { ReactNode } from "react";

function ActionIcon({
  className,
  children,
}: {
  className: string;
  children: ReactNode;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function CopyIcon() {
  return (
    <ActionIcon className="ui-copy-icon">
      <rect x="5.25" y="5.25" width="7.5" height="7.5" rx="1.25" />
      <path d="M10.75 5.25V4.5A1.25 1.25 0 0 0 9.5 3.25h-5A1.25 1.25 0 0 0 3.25 4.5v5A1.25 1.25 0 0 0 4.5 10.75h.75" />
    </ActionIcon>
  );
}

export function BackIcon() {
  return (
    <ActionIcon className="ui-back-icon">
      <path d="m7 3.5-4.5 4.5L7 12.5M2.75 8h10.75" />
    </ActionIcon>
  );
}

export function ChatIcon() {
  return (
    <ActionIcon className="ui-chat-icon">
      <path d="M3.25 3.5h9.5v7H7.5L4.25 13v-2.5h-1z" />
      <path d="M5.5 6.25h5M5.5 8.25h3.25" />
    </ActionIcon>
  );
}

export function CloseIcon() {
  return (
    <ActionIcon className="ui-close-icon">
      <path d="m4.25 4.25 7.5 7.5M11.75 4.25l-7.5 7.5" />
    </ActionIcon>
  );
}

export function StopIcon() {
  return (
    <ActionIcon className="ui-stop-icon">
      <circle cx="8" cy="8" r="5.25" />
      <rect
        x="6"
        y="6"
        width="4"
        height="4"
        rx="0.5"
        fill="currentColor"
        stroke="none"
      />
    </ActionIcon>
  );
}

export function DownloadIcon() {
  return (
    <ActionIcon className="ui-download-icon">
      <path d="M8 2.75v7.5M5.25 7.75 8 10.5l2.75-2.75M3 12.75h10" />
    </ActionIcon>
  );
}

export function FullscreenIcon({ active = false }: { active?: boolean }) {
  return (
    <ActionIcon className="ui-fullscreen-icon">
      {active ? (
        <path d="M6.25 2.75v3.5h-3.5M9.75 2.75v3.5h3.5M6.25 13.25v-3.5h-3.5M9.75 13.25v-3.5h3.5" />
      ) : (
        <path d="M6 3H3v3M10 3h3v3M6 13H3v-3M10 13h3v-3" />
      )}
    </ActionIcon>
  );
}

export function HistoryIcon() {
  return (
    <ActionIcon className="ui-history-icon">
      <circle cx="8" cy="8" r="5" />
      <path d="M8 5.25V8l2 1.25" />
    </ActionIcon>
  );
}

export function HelpIcon() {
  return (
    <ActionIcon className="ui-help-icon">
      <circle cx="8" cy="8" r="5.25" />
      <path d="M6.6 6.2a1.45 1.45 0 0 1 2.8.55c0 1.35-1.4 1.45-1.4 2.45" />
      <path d="M8 11.25h.01" />
    </ActionIcon>
  );
}

export function KeyboardIcon() {
  return (
    <ActionIcon className="ui-keyboard-icon">
      <rect x="2.25" y="4" width="11.5" height="8" rx="1.5" />
      <path d="M4.25 6.25h.01M6.75 6.25h.01M9.25 6.25h.01M11.75 6.25h.01M4.25 8.5h.01M6.75 8.5h.01M9.25 8.5h.01M11.75 8.5h.01M5 10.5h6" />
    </ActionIcon>
  );
}

export function MoonIcon() {
  return (
    <ActionIcon className="ui-moon-icon">
      <path d="M10.8 12.4A5.25 5.25 0 0 1 5.6 3.2a4.7 4.7 0 1 0 5.2 9.2Z" />
    </ActionIcon>
  );
}

export function IterateIcon() {
  return (
    <ActionIcon className="ui-iterate-icon">
      <path d="M12.75 6A5 5 0 0 0 4.2 4.3L3 5.5M3 2.75V5.5h2.75M3.25 10A5 5 0 0 0 11.8 11.7l1.2-1.2M13 13.25V10.5h-2.75" />
    </ActionIcon>
  );
}

export function PlusIcon() {
  return (
    <ActionIcon className="ui-plus-icon">
      <path d="M8 3v10M3 8h10" />
    </ActionIcon>
  );
}

export function RestoreIcon() {
  return (
    <ActionIcon className="ui-restore-icon">
      <path d="M3.25 3.25v4h4" />
      <path d="M3.5 7.25a5 5 0 1 1 1.4 4.35" />
    </ActionIcon>
  );
}

export function SendIcon() {
  return (
    <ActionIcon className="ui-send-icon">
      <path d="M8 12.75v-9.5M4.25 7 8 3.25 11.75 7" />
    </ActionIcon>
  );
}

export function SunIcon() {
  return (
    <ActionIcon className="ui-sun-icon">
      <circle cx="8" cy="8" r="2.4" />
      <path d="M8 2.25v1.2M8 12.55v1.2M3.95 3.95l.85.85M11.2 11.2l.85.85M2.25 8h1.2M12.55 8h1.2M3.95 12.05l.85-.85M11.2 4.8l.85-.85" />
    </ActionIcon>
  );
}
